import { render, staticRenderFns } from "./m-template.vue?vue&type=template&id=609119ac&scoped=true&"
import script from "./m-template.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-template.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-template.vue?vue&type=style&index=0&id=609119ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609119ac",
  null
  
)

export default component.exports